var last = 0;
var socket = '';
var socketGame = '';
export default{
	// 防抖
	throttle(fn, interval) {
		return new Promise((resolve, reject) => {
			var timer;
			var interval = interval || 3000;
			var now = +new Date();
			if (now - last > interval) {
				last = now;
				resolve(fn);
			}
		})
	},
	//判断是否有token
	login_token(){
		var token = uni.getStorageSync('token');
		if(!token){
			uni.redirectTo({
				url: '../public/login'
			});
		}
	},
	//小于10补零
	add0(m){
		return m<10?'0'+m:m
	},
	//时间戳转换日期
	timeFormat(timestamp){
		//timestamp是整数，否则要parseInt转换,不会出现少个0的情况
		let date = new Date(timestamp*1000);
		let y = date.getFullYear();
		let MM = date.getMonth() + 1;
		MM = MM < 10 ? ('0' + MM) : MM;
		let d = date.getDate();
		d = d < 10 ? ('0' + d) : d;
		let h = date.getHours();
		h = h < 10 ? ('0' + h) : h;
		let m = date.getMinutes();
		m = m < 10 ? ('0' + m) : m;
		let s = date.getSeconds();
		s = s < 10 ? ('0' + s) : s;
		return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
	},
	//时间戳转换日期
	noYQtimeFormat(timestamp){
		//timestamp是整数，否则要parseInt转换,不会出现少个0的情况
		let date = new Date(timestamp);
		let y = date.getFullYear();
		let MM = date.getMonth() + 1;
		MM = MM < 10 ? ('0' + MM) : MM;
		let d = date.getDate();
		d = d < 10 ? ('0' + d) : d;
		let h = date.getHours();
		h = h < 10 ? ('0' + h) : h;
		let m = date.getMinutes();
		m = m < 10 ? ('0' + m) : m;
		let s = date.getSeconds();
		s = s < 10 ? ('0' + s) : s;
		return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
	},
	//c++转换日期
	getFDate(val) {
		var date = new Date(parseInt(val.replace("/Date(", "").replace(")/", ""), 10));
		let y = date.getFullYear();
		let MM = date.getMonth() + 1;
		MM = MM < 10 ? ('0' + MM) : MM;
		let d = date.getDate();
		d = d < 10 ? ('0' + d) : d;
		let h = date.getHours();
		h = h < 10 ? ('0' + h) : h;
		let m = date.getMinutes();
		m = m < 10 ? ('0' + m) : m;
		let s = date.getSeconds();
		s = s < 10 ? ('0' + s) : s;
		return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
	},
	//时间戳转换日期没有秒
	nomiaotimeFormat(timestamp){
		//timestamp是整数，否则要parseInt转换,不会出现少个0的情况
		let date = new Date(timestamp*1000);
		let y = date.getFullYear();
		let MM = date.getMonth() + 1;
		MM = MM < 10 ? ('0' + MM) : MM;
		let d = date.getDate();
		d = d < 10 ? ('0' + d) : d;
		let h = date.getHours();
		h = h < 10 ? ('0' + h) : h;
		let m = date.getMinutes();
		m = m < 10 ? ('0' + m) : m;
		let s = date.getSeconds();
		s = s < 10 ? ('0' + s) : s;
		return y + '-' + MM + '-' + d  + ' ' + h + ':' + m;
	},
	//时间戳转换日期天
	nomiaotimeToday(timestamp){
		//timestamp是整数，否则要parseInt转换,不会出现少个0的情况
		let date = new Date(timestamp*1000);
		let y = date.getFullYear();
		let MM = date.getMonth() + 1;
		MM = MM < 10 ? ('0' + MM) : MM;
		let d = date.getDate();
		d = d < 10 ? ('0' + d) : d;
		let h = date.getHours();
		h = h < 10 ? ('0' + h) : h;
		let m = date.getMinutes();
		m = m < 10 ? ('0' + m) : m;
		let s = date.getSeconds();
		s = s < 10 ? ('0' + s) : s;
		return y + '-' + MM + '-' + d ;
	},
	//把2020-02-11T12:24:18.000+0000转换成正常格式
	liaotianTime(date){
		var json_date = new Date(date).toJSON();
		return new Date(+new Date(json_date) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
	},
	//把2020-02-11T12:24:18.000+0000转换成正常格式
	liaotianTimes(date){
		var json_date = new Date(date).toJSON();
		var aaa =  new Date(+new Date(json_date) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
		aaa = aaa.split(' ')[0].split('-')[1] + '-' + aaa.split(' ')[0].split('-')[2]
		return aaa;
	},
	//倒计时
	daojishi(time){
		var EndTime= time//结束时间
		var NowTime =  new Date();//当前时间
		//后台给我的是10位 精确到秒的  所有下面我就除以了1000，不要小数点后面的
		var t =EndTime -(NowTime.getTime()/1000).toFixed(0);
		if(t < 0){
			return '0:0:0'
		}
		//如果后台给的是毫秒 上面不用除以1000  下面的计算时间也都要除以1000 这里我去掉1000了
		var d=Math.floor(t/60/60/24);//天 var d=Math.floor(t/1000/60/60/24)
		var h=Math.floor(t/60/60%24);//时 var h=Math.floor(t/1000/60/60%24)
		var m=Math.floor(t/60%60);//分 var m=Math.floor(t/1000/60%60)
		var s=Math.floor(t%60);//秒 var s=Math.floor(t/1000%60)
		if(parseInt(d)<10){
			d="0"+d;
		}
		if(parseInt(h)<10){
			h="0"+h;
		}
		if(parseInt(m)<10){
			m="0"+m;
		}
		if(parseInt(s)<10){
			s="0"+s;
		}
		if(d>0){
			return d+'天'+ h+':'+m+':'+s
		}else{
			return h+':'+m+':'+s
		}
		
	},
	//字符串截取
	GetQueryString(href,name){
		var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
		var r = href.split('?')[1].match(reg);
		if(r!=null)return  unescape(r[2]); return null;
	},
	//保留小数
	twoNum(num,ws){
		if(num == null || num == ''){
			return '0.00';
		}
		var num = String(num);
		if(num.indexOf(".")==-1){
			return num;
		}
		// if(num.split(".")[1].length < wx){
		// 	return num;
		// }
		var num = Number(num).toFixed(ws);
		return num;
	},
	//去除后缀是0的小数
	numZero(num){
		if(num == 0 || num == ''){
			return '0';
		}
	},
	//手机号显示*号
	moblieHide(moblie){
		var qian = moblie.slice(0,3);
		var hou = moblie.slice(7,11);
		return qian + '****' + hou;
	},
	//手机号显示*号
	mobliea(moblie){
		var hou = moblie.slice(7,11);
		return '****' + hou;
	},
	onNull(data){
		var i = 0;
		data.forEach((item,index)=>{
			if(item != ''){
				i++
			}
		})
		if(i != data.length){
			return true;
		}
	},
	//换行符转换数组
	wrap(str){
		if (!str) {
			return []
		}
		let arr = str.split(/\n/g)
		if (!arr[arr.length]) { // 如果最后一行后面有换行符，删除数组最后一项空字符串
			arr.pop()
		}
		return arr
	},
	//将秒转化为时分秒
	formatSeconds(value) {
	    let result = parseInt(value)
	    let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
	    let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
	    let s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));
	 
	    let res = '';
	    if(h !== '00') res += `${h}h`;
	    if(m !== '00') res += `${m}min`;
	    res += `${s}s`;
	    return res;
	},
	//跳转qq
	getQQ(qqnum){
		plus.runtime.openWeb('http://wpa.qq.com/msgrd?v=3&uin='+qqnum+'&site=qq&menu=yes');
	},
	//储存socket
	setSocket(socketText){
		socket = socketText;
	},
	//取socket
	getSocket(){
		return socket;
	},
	//储存socket
	setSocketGame(socketText){
		socketGame = socketText;
	},
	//取socket
	getSocketGame(){
		return socketGame;
	},
	//获取指定位数的随机数
	getRandom(num){
	    return Math.floor((Math.random()+Math.floor(Math.random()*9+1))*Math.pow(10,num-1));
	}
}






// WEBPACK FOOTER //
// ./src/common/index.js